<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { TwistBox, TwistStack } from '@twist/core';
  import type { Job } from '$lib/careers/types';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import BlockButton from '$components/Button/BlockButton.svelte';
  import JobContent from './JobContent.svelte';
  import ApplyButton from './ApplyButton.svelte';
  import CareersThemeProvider, { getBUTheme } from './CareersThemeProvider.svelte';

  export let job: Job;

  const dispatch = createEventDispatcher();
</script>

<JobContent content={job.content} />

<CareersThemeProvider theme={getBUTheme(job.bu, 'light')}>
  <TwistBox marginTop={toFluidVarInput(36, 36)}>
    <TwistStack direction={{ min: 'column', lg: 'row' }} spacing={4}>
      <TwistBox>
        <ApplyButton on:click={() => dispatch('apply-clicked')} />
      </TwistBox>
      <TwistBox>
        <BlockButton
          fullWidth
          fontSize={toFluidVarInput(12, 16)}
          on:click
          href="/careers/jobs"
          variant="outline"
          data-dd-action-name="See all jobs button"
        >
          See all jobs
        </BlockButton>
      </TwistBox>
    </TwistStack>
  </TwistBox>
</CareersThemeProvider>
